/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import moment, {min} from 'moment'
import jMoment from 'moment-jalaali'
import InputMask from 'react-input-mask'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import Select from 'react-select'
import FromToPicker from '../BaseComponent/FromToPicker'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import AutoComplete from '../BaseComponent/autocomplete'

class ReportWeight extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      selectedOption: [],
      fromDate: '',
      toDate: '',
      fromHour: '00:00',
      toHour: '23:59',
      providerId: ''
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {
    //     if (response.data.error == null) {
    //         var result = response.data.object;
    //         for (let i = 0; i < result.length; i++) {
    //             result[i]['value'] = result[i].providerId;
    //             result[i]['label'] ='شناسه :' + result[i].providerId + '-' + result[i].title;
    //         }
    //         this.setState({
    //             providers: response.data.object
    //         })
    //     }
    //     // alert(JSON.stringify(response.data))
    // }).catch((error) => {
    //     alert(JSON.stringify(error))
    // });
  }
  handleChange = (selectedOption) => {
    this.setState({selectedOption})
    // alert(JSON.stringify(selectedOption))
    console.log(`Option selected:`, selectedOption)
  }
  submit(e) {
    e.preventDefault()
  }

  getPDF() {
    let input_supplierName = this.state.providerId
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let toHour = this.state.toHour
    let fromHour = this.state.fromHour

    if (maxDate == '' || minDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if (fromHour == '' || toHour == '') {
      message.error('هر دو ساعت وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else if (!toHour.match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g)) {
      message.error('ساعت انتها معتبر نیست')
    } else if (!fromHour.match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g)) {
      message.error('ساعت ابتدا معتبر نیست')
    } else {
      let fromJalali = this.convertDigit(jMoment(maxDate).format('jYYYY/jMM/jDD'))
      let finalMinDate = this.epochFromLastLayer(fromJalali)

      let toJalali = this.convertDigit(jMoment(maxDate).format('jYYYY/jMM/jDD'))
      let finalMaxDate = this.epochToLastLayer(toJalali)
      JASPERREPORT(
        `report/jasper/weight/result?fromTime=${finalMinDate}&toTime=${finalMaxDate}&providerId=${input_supplierName}`
      )
    }
  }

  epochFromLastLayer = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + this.state.fromHour
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }

  epochToLastLayer = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)

      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let to = miladiDate + ' ' + this.state.toHour + ':00'
      let toEpoch = moment.utc(to).valueOf()
      if (n >= 0) {
        return toEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return toEpoch - 3.5 * 3600 * 1000
      } else {
        return toEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  weightGroupeProduct() {
    let input_supplierName = this.state.providerId
    let minDate = this.state.fromDate
    let maxDate = this.state.toDate
    let toHour = this.state.toHour
    let fromHour = this.state.fromHour

    if (maxDate == '' || minDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if (fromHour == '' || toHour == '') {
      message.error('هر دو ساعت وارد شود')
    } else if ((minDate != '' || minDate == null) && isNaN(minDate)) {
      message.error('فرمت تاریخ ابتدا صحیح نیست')
    } else if ((maxDate != '' || maxDate == null) && isNaN(maxDate)) {
      message.error('فرمت تاریخ انتها صحیح نیست')
    } else if (!toHour.match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g)) {
      message.error('ساعت انتها معتبر نیست')
    } else if (!fromHour.match(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g)) {
      message.error('ساعت ابتدا معتبر نیست')
    } else {
      let fromJalali = this.convertDigit(jMoment(maxDate).format('jYYYY/jMM/jDD'))
      let finalMinDate = this.epochFromLastLayer(fromJalali)

      let toJalali = this.convertDigit(jMoment(maxDate).format('jYYYY/jMM/jDD'))
      let finalMaxDate = this.epochToLastLayer(toJalali)
      JASPERREPORT(
        `report/jasper/weight/product?fromTime=${finalMinDate}&toTime=${finalMaxDate}&providerId=${input_supplierName}`
      )
    }
  }
  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changeFromHour = (fromHour) => {
    this.setState({
      fromHour
    })
  }

  changeToHour = (toHour) => {
    this.setState({
      toHour
    })
  }

  render() {
    let {selectedOption} = this.state
    return (
      <div className="rtl">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>انبار</li>
            <li>گزارش وزن کشی</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش وزن کشی</p>
            </div>

            <FromToPicker
              onChangeFromDate={this.handleChangeFromDate}
              onChangeToDate={this.handleChangeToDate}
              fromLabel="تاریخ شروع از"
              toLabel="تاریخ شروع تا"
              force={true}
              defaulValue={true}
              fromId="from"
              toId="to"
              fromHour={this.state.fromHour}
              toHour={this.state.toHour}
              onChangeFromHour={this.changeFromHour}
              onChangeToHour={this.changeToHour}
              hasHour
            />

            <div className="formComponent selectComponent">
              <AutoComplete
                label="تامین کننده"
                api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                textField="title"
                valueField="providerId"
                id="provider"
                value={this.state.providerId}
                setValue={(providerId) => this.setState({providerId})}
              />

              {/* <label>تامین کننده :‌</label>
                            <Select
                                value={selectedOption}
                                onChange={this.handleChange}
                                options={this.state.providers}
                                isMulti={false}
                                isClearable={true}
                                placeholder={''}
                                id="input_supplierName"
                                name="input_supplierName"
                                tabIndex='1'
                            /> */}
            </div>
            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getPDF.bind(this)}>
                گزارش وزن کشی
              </button>

              <button className="btn btn-info btn-block jasperBtn" onClick={this.weightGroupeProduct.bind(this)}>
                گزارش وزن کشی با گروه بندی محصول
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default ReportWeight
